module.exports = __webpack_public_path__ + "img/u_sign-out-alt.9b1d88c8.svg";